import { render, staticRenderFns } from "./indexs.vue?vue&type=template&id=39311331&scoped=true&"
import script from "./indexs.vue?vue&type=script&lang=js&"
export * from "./indexs.vue?vue&type=script&lang=js&"
import style0 from "./indexs.vue?vue&type=style&index=0&id=39311331&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39311331",
  null
  
)

export default component.exports